import { useCallback, useEffect } from "react";

export function useScrollToTop() {
  const scrollToTop = useCallback((behavior = "smooth") => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior,
    });
  }, []);

  useEffect(() => {
    scrollToTop();
  }, [scrollToTop]);

  return { scrollToTop };
}
